var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters['merchant/theme'].details_template === 1)?_c('ItemMobile1'):(_vm.$store.getters['merchant/theme'].details_template === 2)?_c('ItemMobile2'):_c('span')}
var staticRenderFns = []

export { render, staticRenderFns }